import { IDatahubCase } from "../cases/models"

export enum TextGroup {
  HeadingAndIntroduction = "HEADING_AND_INTRODUCTION",
  Section = "SECTION",
  AreaDescription = "AREA_DESCRIPTION",
  POI = "POI",
  SpeechMovieText = "SPEECH_MOVIE_TEXT",
  Ads = "ADS",
  SocialMedia = "SOCIAL_MEDIA",
  USP = "USP",
  Other = "OTHER",
}

export interface ICaseText {
  content: string
  name: string
  title: string
}

export interface INormalizedCaseText extends ICaseText {
  normalizedTitle: string
  titleIndex: number
}

export interface ICaseTextGroup {
  groupName: string
  texts: INormalizedCaseText[]
}

export interface ISaveTextParams extends Pick<ICaseText, "content" | "name"> {
  caseId: IDatahubCase["id"]
}

export interface IGetTextHistoryParams {
  caseId: IDatahubCase["id"]
  name: ICaseText["name"]
}
